import type AiCostsFilterView from '@UI/Pages/Administration/AiCosts/Filters/AiCostsFilterView';
import type AiCostFilterOptionsView from '@UI/Store/AiCosts/Views/AiCostFilterOptionsView';

/** Name of the narrowest filtered item (user, then facility, then structure). */
const describeFilteredPerimeter = (
	filters: AiCostsFilterView,
	options: AiCostFilterOptionsView | null,
): string => {
	if (filters.userId !== null) {
		return options?.users.find((user) => user.id === filters.userId)?.label ?? "L'utilisateur filtré";
	}

	if (filters.facilityId !== null) {
		return (
			options?.facilities.find((facility) => facility.id === filters.facilityId)?.label ??
			"L'agence filtrée"
		);
	}

	return (
		options?.organizations.find((organization) => organization.id === filters.organizationId)?.label ??
		'La structure filtrée'
	);
};

export default describeFilteredPerimeter;
